import { render, staticRenderFns } from "./IncidentOverview.vue?vue&type=template&id=27fe9106&scoped=true"
import script from "./IncidentOverview.vue?vue&type=script&lang=js"
export * from "./IncidentOverview.vue?vue&type=script&lang=js"
import style0 from "./IncidentOverview.vue?vue&type=style&index=0&id=27fe9106&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27fe9106",
  null
  
)

export default component.exports